import clsx from 'clsx'
import Image from 'next/image'
import Link from 'next/link'
import { useState } from 'react'
import TrialLessonBannerDesktop from './TrialLessonBannerDesktop.jpg'
import TrialLessonBannerMobile from './TrialLessonBannerMobile.jpg'
import { PageInfo } from '@/src/@types/models'
import { FlchTrialLessonCtaBlock } from '@/src/@types/statamic'
import Button from '@/src/components/core/Button'
import { Select } from '@/src/components/core/Select'
import Container from '@/src/components/layout/Container'

export default function Component({
  required_text,
  pageInfo,
}: FlchTrialLessonCtaBlock & { pageInfo: PageInfo }) {
  const {
    locationName,
    locationId,
    bookable = true,
    locations = [],
  } = pageInfo.flchSettings ?? {}

  const [selectedLocationId, setSelectedLocationId] = useState('')

  const selectedLocation = bookable
    ? locationId
    : selectedLocationId || undefined
  const bookingHref =
    selectedLocation !== undefined
      ? `/probelektion?location=${selectedLocation}`
      : '/probelektion'

  return (
    <section
      className={clsx('relative overflow-hidden text-white', {
        'mt-20 md:mt-32': pageInfo.newSpacing,
      })}
      style={{ backgroundColor: 'rgb(13, 11, 63)' }}
    >
      <Image
        src={TrialLessonBannerMobile}
        alt=""
        aria-hidden
        fill
        sizes="100vw"
        className="object-cover grayscale md:hidden"
      />
      <Image
        src={TrialLessonBannerDesktop}
        alt=""
        aria-hidden
        fill
        sizes="100vw"
        className="hidden object-cover grayscale md:block"
      />
      <div
        className="absolute inset-0 md:hidden"
        style={{
          background:
            'linear-gradient(180deg, rgba(13, 11, 63, 1) 0%, rgba(13, 11, 63, 0.78) 48%, rgba(13, 11, 63, 0) 100%)',
        }}
      />
      <div
        className="absolute inset-0 hidden md:block"
        style={{
          background:
            'linear-gradient(90deg, rgba(13, 11, 63, 0.98) 35%, rgba(13, 11, 63, 0.6) 62%, rgba(13, 11, 63, 0) 100%)',
        }}
      />
      <Container className="relative z-10">
        <div className="flex flex-col justify-center pt-12 pb-20 md:min-h-120 md:py-20">
          <h2 className="text-4xl font-black md:text-20xl">
            Deine Probelektion für 59 CHF
            {locationName && ` in ${locationName}`}
          </h2>
          <p className="mt-4 max-w-160 md:mt-6 md:text-lg">{required_text}</p>
          {!bookable && locations.length > 0 && (
            <div className="mt-8 w-full max-w-100">
              <Select
                label="Standort"
                labelType="srOnly"
                color="white"
                placeholderText="Standort wählen"
                value={selectedLocationId}
                onChange={(e) => setSelectedLocationId(e.target.value)}
                className="text-base! text-gray-900"
              >
                {locations.map((location) => (
                  <option key={location.id} value={location.id}>
                    {location.name}
                  </option>
                ))}
              </Select>
            </div>
          )}
          <Button
            as={Link}
            href={bookingHref}
            version="white-gray"
            className={clsx('self-start', bookable ? 'mt-8' : 'mt-4')}
          >
            Probelektion buchen
          </Button>
        </div>
      </Container>
    </section>
  )
}
